import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LearnTagId = Brand<number, 'TryThisTagId'>;
export const LearnTagId = createBranded<LearnTagId>();
